{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/VAS",
	"name": "VAS",
	"language": "fr-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "VAS",
	"purpose": "Mesure l’intensité de la douleur à l’aide d’une échelle visuelle",
	"description": "Contrôle de la douleur chez le patient à l’aide d’un autorapport sur une échelle à un item.",
	"item": [
		{
			"linkId": "110200",
			"text": "Sur une échelle de 0 à 10, où se situe votre douleur ? (0 = aucune douleur, 10 = douleur insupportable)",
			"type": "integer",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/minValue",
					"valueInteger": 0
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/maxValue",
					"valueInteger": 10
				}
			],
			"required": true
		}
	]
}
